import { type RefObject } from 'react'
import { gaTrack } from '../shared/track.js'
import { useIntersectionObserverDelay } from './useIntersectionObserver.js'
import { useAiuiContext } from '../biz-components/AiuiProvider/index.js'

interface ExposureOptions {
  componentType: string
  componentName: string
  componentTitle?: string
  componentDescription?: string
  navigation?: string
  pageGroup?: string
  position?: number
}

export const useExposure = (
  ref: RefObject<HTMLDivElement>,
  { componentType, componentName, componentTitle, componentDescription, navigation = '', position = 1 }: ExposureOptions
) => {
  const { trackingData, onExposure } = useAiuiContext()

  useIntersectionObserverDelay(ref, {
    once: true,
    threshold: 0.5,
    delay: 2000,
    callback: () => {
      const pageGroup = trackingData.pageGroup || 'Home Page'

      if (onExposure) {
        // Custom handler from AiuiProvider
        onExposure({
          componentType,
          componentName,
          componentTitle,
          componentDescription,
          navigation,
          pageGroup,
          position,
        })
      } else {
        // Default GA behavior
        // TODO: 删除这个分支，只保留 onExposure 逻辑，让使用方完全控制曝光埋点
        gaTrack({
          event: 'ga4Event',
          event_name: 'component_impression',
          event_parameters: {
            page_group: pageGroup,
            component_type: componentType,
            component_name: componentName,
            position: position,
            creative_id: '',
            component_title: componentTitle,
            component_description: componentDescription,
            navigation: navigation,
          },
        })
      }
    },
  })
}
